import type { ReactNode } from 'react'

export interface SettingsSaveBarProps {
  children: ReactNode
  className?: string
}

/**
 * The Save row at the end of a Settings tab, kept at the bottom of the screen
 * while the tab scrolls (owner, 2026-09-29: on a phone the button sat below a
 * long form and had to be scrolled to).
 *
 * Sticky inside MainLayout's scrolling <main>. Below lg SettingsPage turns
 * <main> white with no padding and carries the padding itself (owner,
 * 2026-09-30), so the bar sticks at the bottom of the screen with bottom-0, and
 * its negative bottom margin cancels the page's bottom padding so that where it
 * rests at the end of a tab it reaches the screen edge. The home-indicator inset
 * goes inside the bar, below the buttons. It relies on being the last thing on
 * the page: anything after it in the page's space-y column puts a gap under it.
 * From lg it floats above <main>'s p-6 as a bordered bar.
 * Full width on a phone (it undoes the page's px-4). The last child is pushed
 * to the right: a lone Save sits right, and Reset + Save split left and right.
 */
export function SettingsSaveBar({ children, className = '' }: SettingsSaveBarProps) {
  return (
    <div
      data-testid="settings-save-bar"
      className={`sticky bottom-0 z-20 -mx-4 mb-[calc(max(env(safe-area-inset-bottom),1rem)*-1)] lg:mb-0 flex items-center gap-3 border-t border-base-200 bg-base-100/95 px-4 pt-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] backdrop-blur lg:mx-0 lg:rounded-box lg:border lg:pb-3 [&>:last-child]:ml-auto ${className}`}
    >
      {children}
    </div>
  )
}
